import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  clearAuthSession,
  getAccessToken,
  getRefreshToken,
  getTenantId,
  notifyAuthSessionChanged,
  saveAuthSession,
} from "./authSession";

const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const authFetchBaseQuery = fetchBaseQuery({
  baseUrl: AUTH_BASE_URL,
});

const apiFetchBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = getAccessToken();

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

let refreshRequest = null;

const refreshAccessToken = async (api, extraOptions) => {
  const refreshToken = getRefreshToken();
  const tenantId = getTenantId();

  if (!refreshToken || !tenantId) {
    clearAuthSession();
    notifyAuthSessionChanged();
    return false;
  }

  const params = new URLSearchParams({ tenant_id: tenantId });
  const refreshResult = await authFetchBaseQuery(
    {
      url: `cas/refresh-token?${params.toString()}`,
      method: "POST",
      body: { refreshToken },
    },
    api,
    extraOptions
  );

  if (refreshResult?.data?.jwtToken && refreshResult?.data?.refreshToken) {
    saveAuthSession(refreshResult.data);
    notifyAuthSessionChanged();
    return true;
  }

  clearAuthSession();
  notifyAuthSessionChanged();
  return false;
};

export const authBaseQuery = authFetchBaseQuery;

export const appBaseQuery = async (args, api, extraOptions) => {
  let result = await apiFetchBaseQuery(args, api, extraOptions);

  if (result?.error?.status !== 401) {
    return result;
  }

  if (!refreshRequest) {
    refreshRequest = refreshAccessToken(api, extraOptions).finally(() => {
      refreshRequest = null;
    });
  }

  const didRefresh = await refreshRequest;

  if (!didRefresh) {
    return result;
  }

  return apiFetchBaseQuery(args, api, extraOptions);
};
